<template>
  <div>
      <div>
        <v-app-bar
          class="navigation"
          elevation="0"
          style="background: none !important"
        >
          <v-avatar color="primary" size="50">
            <v-img
              contain
              lazy-src="../../assets/img/logo-teman-bakat.png"
              max-height="150"
              max-width="250"
              src="../../assets/img/logo-teman-bakat.png"
            ></v-img>
          </v-avatar>
          <template>
            <v-tabs align-with-title v-model="tab">
              <v-tab href="http://temanbakat.id" target="_blank">
                BERANDA
              </v-tab>
              <v-tab
                v-for="item in menuItems"
                :key="item.name"
                @click="onItem = item.id"
              >
                {{ item.text }}
              </v-tab>
            </v-tabs>
          </template>
        </v-app-bar>
        <div>
          <h1 class="mt-2 text-center">Kendala Tidak Menemukan Email Teman Bakat, Coba Cek Spam</h1>
          <div class="d-flex justify-center pa-10" style="width: 100%">
            <v-card
              elevation="4"
              height="100%"
              width="100%"
              class="
                rounded-xl
                pa-10
              "
            >
            <h2 class="text-center">Tutorial Cek Email SPAM</h2>
            <ol>
              <li>
                <div class="mt-5">
                  <p>Pada bagian kiri menu email anda, terdapat menu-menu seperti berikut. Jika anda menggunakan Google Mail (Gmail) klik <b>menu Selengkapnya</b>, jika menggunakan layanan lain, maka menyesuaikan dengan layanannya.</p>
                  <img class="object-fit rounded-lg" style="max-width: 100%;" src="../../assets/img/tutorial/spam-email/spam1.png" alt="Spam 1">
                </div>
              </li>
              <li>
                <div class="mt-5">
                  <p>Setelah klik Selengkapnya akan muncul banyak menu lainnya. Pilih <b>menu Spam</b> untuk melihat email yang masuk atau terbaca sebagai Spam.</p>
                  <img class="object-fit rounded-lg" style="max-width: 100%;" src="../../assets/img/tutorial/spam-email/spam2.png" alt=" Spam 2">
                </div>
              </li>
              <li>
                <div class="mt-5">
                  <p>Lalu pilih dan klik email verifikasi yang dikirimkan oleh Teman Bakat</p>
                  <img class="object-fit rounded-lg" style="max-width: 100%" src="../../assets/img/tutorial/spam-email/spam3.png" alt="Spam 3">
                </div>
              </li>
            </ol>
            </v-card>
          </div>
          <div style="width: 50%"></div>
        </div>
      </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../../components/penjurusan/Footer.vue";
import Splash from "../../components/penjurusan/Splash.vue";
import Menu from "../../components/penjurusan/Menu.vue";

export default {
  name: "academic-psychogram",
  components: {
    Footer,
    Splash,
    Menu,
  },
  data() {
    return {
      menuItems: [],
      tab: 1,
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style>

</style>
